import {
	type CommandConstructor,
	type CommandProperties,
	type SerializableValue,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

/**
 * Pixel dimensions requested by an iframe-hosted native embed.
 *
 * `local` indicates that the dimensions are ephemeral and must not be persisted
 * to the underlying content. `maxHeight` is an optional constraint supplied by
 * the embedded surface.
 */
export interface NativeEmbedRequestResizeCommandParams extends CommandProperties {
	height?: number;
	local?: boolean;
	maxHeight?: number;
	width?: number;
}

/**
 * Shared request-resize command used by native embeds and iframe preview hosts.
 * Techdebt: This command should live in the native embed core package and not be reused without the native embeds frame.
 * Moving this to ai-mate has caused leakage of native embeds specific functionality to the ai-mate package. This will be
 * resolved in https://product-fabric.atlassian.net/jira/browse/CNS-35670
 */
export const NativeEmbedRequestResizeCommand: CommandConstructor<
	NativeEmbedRequestResizeCommandParams,
	SerializableValue
> = createCommand<NativeEmbedRequestResizeCommandParams>('native-embed-request-resize-command');
